import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { CamTranslationGrid } from '../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-translation-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TranslatePipe],
  template: `{{ this.value ?? '' | translate }}`,
})
export class GridTranslationCellComponent extends AbstractCellComponent<any, string> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
}
